<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 550.801 550.801"
  style="enable-background: new 0 0 550.801 550.801"
  xml:space="preserve"
>
  <g>
    <path
      d="M421.628,290.535l-19.591,31.968v0.453H434.9v-32.421c0-8.775,0.454-17.785,1.129-27.24h-0.896
		C430.408,272.75,426.574,281.296,421.628,290.535z"
    />
    <path
      d="M488.426,197.019H475.2v-63.816c0-0.398-0.063-0.799-0.116-1.202c-0.021-2.534-0.827-5.023-2.562-6.995L366.325,3.694
		c-0.032-0.031-0.063-0.042-0.085-0.076c-0.633-0.707-1.371-1.295-2.151-1.804c-0.231-0.155-0.464-0.285-0.706-0.419
		c-0.676-0.369-1.393-0.675-2.131-0.896c-0.2-0.056-0.38-0.138-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
		c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.873v160.545
		c0,17.043,13.824,30.87,30.873,30.87h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
		V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87v-160.54C519.297,210.838,505.47,197.019,488.426,197.019z M97.2,21.605
		h250.193v110.513c0,5.967,4.841,10.8,10.8,10.8h95.407v54.108H97.2V21.605z M357.888,277.932c0,14.85-4.957,27.453-13.954,36.007
		c-11.707,11.043-29.035,15.989-49.307,15.989c-4.503,0-8.553-0.222-11.696-0.675v54.242h-34.006V233.801
		c10.584-1.804,25.439-3.161,46.378-3.161c21.167,0,36.238,4.058,46.385,12.168C351.359,250.454,357.888,263.063,357.888,277.932z
		 M92.67,263.063h-0.458c-0.892,20.479-1.566,43.903-2.7,62.814l-2.684,57.628H55.065l9.688-151.725h45.705l14.85,50.654
		c4.73,17.561,9.456,36.471,12.841,54.253h0.675c4.261-17.561,9.455-37.6,14.402-54.475l16.216-50.433h44.8l8.332,151.725h-33.552
		l-2.247-58.082c-0.686-18.225-1.35-40.299-1.35-62.355h-0.675c-4.725,19.367-11.037,40.988-16.891,58.77l-18.462,59.211h-26.789
		l-16.206-58.768C101.445,304.488,96.277,282.878,92.67,263.063z M453.601,523.353H97.2V419.302h356.4V523.353z M484.888,348.617
		h-17.571v34.889H434.9v-34.889h-64.831v-22.286l55.376-89.15h41.871v85.775h17.571V348.617z"
    />
    <path
      d="M297.096,256.54c-6.972,0-11.697,0.675-14.165,1.345v44.801c2.911,0.675,6.519,0.906,11.476,0.906
		c18.235,0,29.488-9.229,29.488-24.774C323.895,264.872,314.213,256.54,297.096,256.54z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
